import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'

const ColumnSelection = ({
  selectableColumns,
  handleColumnsChange,
  selectedColumnKeys,
  setSelectedColumnKeys,
  customFields,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleCheckboxClick = (column, selected) => {
    handleColumnsChange(column, selected)
  }

  const handleKeydown = (evt) => {
    if (evt.key === 'Escape') setIsOpen(false)
  }

  useEffect(() => {
    if (isOpen) document.addEventListener('keydown', handleKeydown)
    return () => document.removeEventListener('keydown', handleKeydown)
  }, [isOpen])

  const hasSelection = selectedColumnKeys.length > 2

  return (
    <Box sx={{ height: '100%' }}>
      <Typography sx={{ mb: 2, position: 'relative', top: '6px' }}>
        <b>Select columns</b>
      </Typography>

      <Box
        sx={{
          height: 'calc(100% - 58.5px)',
          boxShadow:
            '0px 8px 6px -7px rgb(0 0 0 / 40%) inset, 0px -8px 6px -7px rgb(0 0 0 / 40%) inset',
          mx: -1,
          py: '3px',
        }}
      >
        <Box
          sx={{
            overflow: 'scroll',
            height: '100%',
          }}
        >
          <Box sx={{ px: 3 }}>
            <Box>
              <Button
                onClick={() => {
                  setSelectedColumnKeys(
                    hasSelection
                      ? ['importanceTypeId', 'name']
                      : selectableColumns.map((column) => column.key)
                  )
                }}
              >
                {(hasSelection ? 'Uns' : 'S') + 'elect All'}
              </Button>
            </Box>
            <FormGroup>
              {selectableColumns
                .filter((c) => !c.disabled)
                .map((c) => (
                  <FormControlLabel
                    key={c.key}
                    label={c.label}
                    control={
                      <Checkbox
                        sx={{ padding: '2px' }}
                        checked={selectedColumnKeys.includes(c.key) || false}
                        onChange={(_, val) => handleCheckboxClick(c, val)}
                      />
                    }
                  />
                ))}

              <Divider sx={{ my: 2 }} />
              <Typography>Custom Fields</Typography>

              {customFields.map((c) => {
                const key = `CUSTOM-${c.id}`
                return (
                  <FormControlLabel
                    key={key}
                    label={c.name}
                    control={
                      <Checkbox
                        sx={{ padding: '2px' }}
                        checked={selectedColumnKeys.includes(key) || false}
                        onChange={(_, val) =>
                          handleCheckboxClick({ key, label: c.name }, val)
                        }
                      />
                    }
                  />
                )
              })}
            </FormGroup>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ColumnSelection
